import React, { useEffect, useState } from "react";
const API = process.env.REACT_APP_API_BASE_URL ?? "https://zoompay.co.ke";
const getToken = () => localStorage.getItem("adminToken");

// FINTRAC 24-hour rule view. Flags only: nothing is filed automatically.
export default function Threshold24h() {
  const [r, setR] = useState(null);
  const [err, setErr] = useState(null);
  const [days, setDays] = useState(30);

  useEffect(() => {
    setR(null); setErr(null);
    fetch(`${API}/api/v2/cockpit/compliance/threshold-24h?days=${days}`, { headers: { Authorization: `Bearer ${getToken()}` } })
      .then((x) => x.json()).then((d) => (d.ok ? setR(d) : setErr(d.error || "Failed")))
      .catch((e) => setErr(e.message));
  }, [days]);

  const when = (a, b) => `${new Date(a).toLocaleString()} → ${new Date(b).toLocaleString()}`;
  const Table = ({ rows, keyName, label }) => (
    rows.length === 0 ? <p className="px-6 py-3 text-sm text-gray-500">None in this period.</p> : (
      <table className="w-full text-sm">
        <thead className="bg-gray-50"><tr>
          <th className="px-4 py-2 text-left text-gray-600 font-medium">{label}</th>
          <th className="px-4 py-2 text-left text-gray-600 font-medium">Total in 24h</th>
          <th className="px-4 py-2 text-left text-gray-600 font-medium">Window</th>
          <th className="px-4 py-2 text-left text-gray-600 font-medium">Transfers</th>
        </tr></thead>
        <tbody className="divide-y">
          {rows.map((x) => (
            <tr key={x[keyName]}>
              <td className="px-4 py-2 font-mono text-xs">{x[keyName]}</td>
              <td className="px-4 py-2 font-bold text-red-700">CAD {x.windowTotal.toFixed(2)}</td>
              <td className="px-4 py-2 text-gray-500">{when(x.windowStart, x.windowEnd)}</td>
              <td className="px-4 py-2 font-mono text-xs">{x.transfers.join(", ")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  );

  return (
    <div className="bg-white border rounded-lg shadow-sm">
      <div className="px-6 py-4 border-b flex justify-between items-center flex-wrap gap-2">
        <div>
          <h2 className="font-semibold text-gray-800">24-hour rule: CAD 10,000 threshold</h2>
          <p className="text-xs text-gray-400 mt-0.5">
            Senders or beneficiaries whose transfers within any 24 hours reach CAD 10,000, and senders repeatedly
            sending close to their 24-hour limit. For review; nothing is reported automatically.
          </p>
        </div>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="border rounded-lg px-2 py-1 text-sm">
          {[7, 30, 90].map((d) => <option key={d} value={d}>Last {d} days</option>)}
        </select>
      </div>
      {err && <p className="px-6 py-3 text-sm text-red-600">{err}</p>}
      {!r && !err && <p className="px-6 py-3 text-sm text-gray-400">Loading…</p>}
      {r && (
        <div className="divide-y">
          <div><h3 className="px-6 pt-3 text-sm font-semibold text-gray-700">Senders</h3><Table rows={r.senders} keyName="sender" label="Sender (user id)" /></div>
          <div><h3 className="px-6 pt-3 text-sm font-semibold text-gray-700">Beneficiaries</h3><Table rows={r.beneficiaries} keyName="beneficiary" label="Beneficiary phone" /></div>
          <div>
            <h3 className="px-6 pt-3 text-sm font-semibold text-gray-700">Repeated near-limit transfers (3+ at ≥ 90% of CAD {Number(r.sendCap).toFixed(0)})</h3>
            {r.nearCapPattern.length === 0 ? <p className="px-6 py-3 text-sm text-gray-500">None in this period.</p> : (
              <ul className="px-6 py-3 text-sm space-y-1">
                {r.nearCapPattern.map((x) => <li key={x.sender}><span className="font-mono text-xs">{x.sender}</span>: {x.count} transfers ({x.transfers.join(", ")})</li>)}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
